import * as React from 'react';
import { Input } from 'antd';

import { HeaderConsumer } from '../../../context/HeaderContext';
import { THEME_COLOR } from '../../../constants';


const Search = Input.Search;

export class SearchBarComponent extends React.PureComponent {
  render() {
    return (
      <HeaderConsumer>
        {(headerContext) => headerContext && (
          <Search
            size={"small"}
            placeholder="Search...."
            onSearch={value => headerContext.updateSearchText(value)}
            style={{ width: 300, height: 50, marginRight: 10, color: THEME_COLOR, alignSelf: 'center' }}
          />
        )}
      </HeaderConsumer>
    );
  }
}


// WEBPACK FOOTER //
// ./src/modules/layout/header/SearchBarComponent.tsx